import { render } from "./counter-four.vue?vue&type=template&id=1aec3cce"
import script from "./counter-four.vue?vue&type=script&lang=js"
export * from "./counter-four.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__